import {Drawer} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {Body} from '@/components/FilterDrawer/components/Body';
import {Container} from '@/components/FilterDrawer/components/Container';
import {Footer} from '@/components/FilterDrawer/components/Footer';
import {Header} from '@/components/FilterDrawer/components/Header';
import {Title} from '@/components/FilterDrawer/components/Title';

type Props = React.PropsWithChildren<{
  open: boolean;
  controls: React.ReactNode;
  selectedFilters?: React.ReactNode;
  onClose: () => void;
}>;

export const FilterDrawer: React.FunctionComponent<Props> = ({
  children,
  open,
  controls,
  selectedFilters,
  onClose,
}) => {
  const {t} = useTranslation('general');

  return (
    <Drawer open={open} anchor="right" onClose={onClose}>
      <Container>
        <div>
          <Header onClose={onClose}>
            <Title>{t('filterOverlay.title')}</Title>
          </Header>
          {selectedFilters}
        </div>
        <Body>{children}</Body>
        <Footer>{controls}</Footer>
      </Container>
    </Drawer>
  );
};
